import ApiServer from "../../ApiServer.js";
import * as Html from "../../util/Html.ts";
import {PlaceCache} from "../../server/objects/MapBeans.js";
//import * as googleApi from "../../googleApi.js";
import TPLpicker from "../../widget/place-picker.mustache";

export {init,destroy}
Html.registerWidget('widget/form/place-picker',{init:init,destroy:destroy})

  var FACTOR_TO_RADIAN = Math.PI / (180);
  function worm(add1,add2){
    var
      lat1 = add1.latitude * FACTOR_TO_RADIAN,
      lat2 = add2.latitude * FACTOR_TO_RADIAN,
      lng1 = add1.longitude * FACTOR_TO_RADIAN,
      lng2 = add2.longitude * FACTOR_TO_RADIAN;
    
    return (6365000 * Math.sqrt((lat2 - lat1) * (lat2 - lat1) + Math.pow((lng2 - lng1) * Math.cos(lat2), 2)));
  }
  
  
  

  function filterDuplicatePlace(places){
    var 
      mapByAddress = {}, //will contain all place by address (keeping the smaller radius)
      result = $.grep(places,function(place,idx){ //we fill mapbyAdress while grepping the not temporary
        var oldPlace = mapByAddress[place.address.formattedAddress];
        if(!oldPlace || place.address.radius<oldPlace.address.radius){
          mapByAddress[place.address.formattedAddress] = place;
        }
        return !place.isTemporary;
      });
    $.each(mapByAddress,function(idx,place){
      if(place.isTemporary){
        result.push(place);
      }
    });
    return result;
  }
  
  function initWidget(obj,places){
    var 
      places = filterDuplicatePlace(places),
      lastSearch = {search:'',places:places,items:[]},
      closed = true,
      
      proposeDiv = $('<div class="fw-place-picker"></div>').insertAfter(obj);
    
    obj.setPosition = function(){
      var position = obj.position();
      proposeDiv.css('left',position.left);
      proposeDiv.css('width',obj.outerWidth());
      proposeDiv.css('top',position.top + obj.outerHeight(true)-1);
      proposeDiv.css('max-height',300);
      
    }
    
    
    obj.attr('autocomplete','off');
    
//    var geocoder = new window.google.maps.Geocoder();

    if (obj.data('use-geolocation') && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(geoposition){
        
        places.sort(function(a,b){
          var deltaA = worm(a.address,geoposition.coords);
          var deltaB = worm(b.address,geoposition.coords);
          return deltaA>deltaB?1:-1;
        });
        //we have a radius intersection with the closest place
        if(places.length>0 && worm(places[0].address,geoposition.coords)<geoposition.coords.accuracy + places[0].address.radius){
          obj.val(places[0].address.formattedAddress);
          setPlaceId(places[0].metaId);
        }else{
          //else we georeverse to get an address
          ApiServer.georeverse(Math.round(geoposition.coords.latitude*1000000),Math.round(geoposition.coords.longitude*1000000),function(georeversed){
            lastSearch.search = georeversed.formattedAddress;
            obj.val(georeversed.formattedAddress);
          });
        }
      });
    }
    
    
    function propose(){
      obj.setPosition();
      
      lastSearch.places.sort(function(a,b){
        if(a.isTemporary!==b.isTemporary){
          return b.isTemporary?-1:1;
        }
        return 0;
      });
      Html.setHtml(proposeDiv,TPLpicker,lastSearch);
      proposeDiv.show()
      
    }
    
    obj.close = function(){
      proposeDiv.hide();
    }
    function setPlaceId(placeId){
      obj.prev("[name=placeId]").val(placeId).trigger('change')
    }
    
    $(window).on('resize', obj.setPosition)
    
    $(document).on('click',obj.close)
    
    proposeDiv.delegate('.fw-place-picker-item','click',function(evt){
      closed = true;
      obj.val($(this).attr('data-fw-formattedaddress'));
      setPlaceId($(this).attr('data-fw-metaId'))
    });
    obj.on('click',function(evt){
      evt.stopPropagation();
      propose();
    });
    
    obj.on('focus',function(){
      closed = false;
      obj.val(lastSearch.search);
      obj.select();
      setPlaceId('');
      propose();
    });
    obj.interval = setInterval(function(){
      if(closed) return;
      var 
        value = obj.val(),
        lowerCaseValue = value.trim().toLowerCase();
      
      if(value===lastSearch.search){
        return;
      }
      if (lowerCaseValue.length===0) {
        lastSearch = {search:value,places:places,items:[]}
        propose();
        return;
      }
      //seek in place 
      lastSearch = {search:value,places:$.grep(places,function(o){
        if(o.name.toLowerCase().indexOf(lowerCaseValue)!==-1){
          return true;
        }
        if(o.address.formattedAddress.toLowerCase().indexOf(lowerCaseValue)!==-1){
          return true;
        }
        return false;
      }),items:[]};
      
       propose();
       /*
      //if too much place stop there
      if(lastSearch.places.length>=10){
        propose();
      }else{
        //todo add country or bounds in this
        geocoder.geocode({address:value,language:i18n.getShortLanguage(),region:mostUsedCountry}, function(results, status){
          if (status === window.google.maps.GeocoderStatus.OK) {
            lastSearch.items = $.map(results,function(item){
              var res = {
                formattedAddress:item.formatted_address
              };
              $.each(item.address_components,function(idx,component){
                if(component.types.indexOf('locality')!=-1){
                  res.attribute2Town = component.long_name;
                }
                if(component.types.indexOf('country')!=-1){
                  res.attribute1Country = component.long_name;
                }
                  
              });
              return res;
            });
            propose();
          } 
        });
      }*/
      
    },200);
    
  }
  function init(obj){
    PlaceCache.need().then(places=>{initWidget(obj,places)})
  }
  function destroy(obj){
    clearInterval(obj.attr('interval'));
    $(window).off('resize', obj.setPosition);
    $(document).on('click',obj.close)
  }